'use strict';
/* global _minimal_menu_enabled:false */

document.addEventListener('DOMContentLoaded', () => {
	(() => {
		const body = document.querySelector('body');
		const side_menu_overlay = document.getElementById('side_menu_overlay');
		const side_menu_close = document.getElementById('side_menu_close');
		const main_menu = document.getElementById('main_menu');
		const main_menu_toggle = document.getElementById('main_menu_toggle');
		const messages_holder = document.querySelector('.messages_holder');
		const help_widget = document.querySelector('.widget_button_help');
		// const minimal_menu_enabled = typeof _minimal_menu_enabled !== 'undefined' ? _minimal_menu_enabled : false;
		// Disable scrolling height modification Task: 51144
		const minimal_menu_enabled = false
		let previous_scroll = 0;
		let current_scroll = 0;
		let offset = 0;

		try {
			/* binds */
			document.addEventListener('scroll', updateMainMenuLocation);
			document.addEventListener('resize', updateMainMenuLocation);
			body.addEventListener('keyup', e => {
				if (e.key === 'Escape') {
					closeSideMenu();
				}
			});
			if (main_menu_toggle) {
				main_menu_toggle.addEventListener('click', openSideMenu);
			}
			if (side_menu_overlay) {
				side_menu_overlay.addEventListener('click', closeSideMenu);
			}
			if (side_menu_close) {
				side_menu_close.addEventListener('click', closeSideMenu);
			}

			/* init */
			updateMainMenuLocation();

			if (window.outerWidth > 991 && help_widget) {
				help_widget.classList.add('show');
			}
		} catch (e) {
			console.warn(e);
		}

		/* functions */
		function openSideMenu() {
			body.classList.add('menu_open');
		}
		function closeSideMenu() {
			body.classList.remove('menu_open');
		}
		function updateMainMenuLocation() {
			const menu_height = main_menu.offsetHeight;
			const menu_header = main_menu.parentElement;
			current_scroll = window.pageYOffset;
			offset = 0;

			if (messages_holder) {
				const message_holders = messages_holder.querySelectorAll('.message_holder');
				message_holders.forEach(message_holder => {
					offset += message_holder.offsetHeight;
				});
			}

			if (offset < current_scroll) {
				menu_header.style.minHeight = `${menu_height / 10}rem`;
				main_menu.classList.add('scrolling');
			} else {
				menu_header.style.minHeight = '0';
				main_menu.classList.remove('scrolling');
			}

			//shrink/expand mobile menu
			if (minimal_menu_enabled) {
				if (window.outerWidth <= 991) {
					if (current_scroll > previous_scroll) { //down
						if (current_scroll > menu_height + offset) {
							//shrink menu and hide bottom navbar
							main_menu.classList.add('minimal');
							if (help_widget) {
								help_widget.classList.add('show');
							}
						}
					} else { //up
						if (current_scroll < menu_height + offset) {
							//expand menu and hide bottom navbar
							main_menu.classList.remove('minimal');
							if (help_widget) {
								help_widget.classList.remove('show');
							}
						}
					}
					previous_scroll = current_scroll;
				}
			}
		}
	})();
});
